
import { mapGetters, mapState, mapMutations } from 'vuex';
import _debounce from 'lodash/debounce';
import {
  concatCatalogRoutePath,
  generateCategoryUrl,
  getAllActiveCategories,
} from '@/plugins/helpers/catalog';
import CustomRange from '@/components/elements/CustomRange';
import CustomCheck from '@/components/elements/CustomCheck';
import CustomAccordion from '@/components/elements/CustomAccordion';
import CategoriesTree from '@/components/catalog/categoriesTree';
import Button from '@/components/elements/Button';

export default {
  name: 'FilterCatalog',
  components: {
    CustomRange,
    CustomCheck,
    CustomAccordion,
    CategoriesTree,
    Button,
  },
  props: {
    type: {
      type: String,
      default: 'catalog',
    },
    // loadingCatalog: {
    //   type: Boolean,
    //   default: false,
    // },
    categories: {
      type: Array,
      required: true,
    },
    productsNum: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      format: {
        to(value) {
          return Math.round(value);
        },
        from(value) {
          return Number(value);
        },
      },
      maxCountFilters: 8,
      isFilterShow: false,

      loadingCatalog: false,
      tempRangeValues: {},
    };
  },
  computed: {
    ...mapGetters('currency', { getCurrentSymbol: 'getCurrentSymbol' }),
    ...mapGetters('catalog', ['filterSegments', 'routeSegments']),
    ...mapState('catalog', ['filters', 'filtersStateMap']),
    ...mapState('route', {
      code: (state) => state.params.category,
      entityCode: (state) => state.params.entityCode,
      tagCode: (state) => state.params.tag || '',
    }),
    mqIsMobile() {
      return (
        this.$mq === 'mobileXs' ||
        this.$mq === 'mobile' ||
        this.$mq === 'tablet'
      );
    },
    listFilters() {
      const filters = this.filters || [];
      const map = this.filtersStateMap || {};

      return filters.map((filter) => {
        const isOverflow = filter.items
          ? filter.items.length > this.maxCountFilters
          : false;
        const { isExpanded, showMore } = map[filter.name];
        const items =
          isOverflow && !showMore
            ? [...filter.items.slice(0, this.maxCountFilters)]
            : filter.items;

        return {
          ...filter,
          items,
          isExpanded,
          isOverflow,
          showMore,
        };
      });
    },
    isFiltersPage() {
      return this.$route.path.includes('filters');
    },
    parentCategories() {
      if (!this.code) return this.categories;

      const [parent] = getAllActiveCategories(this.categories, this.code);

      if (!parent) return [];

      return [parent];
    },
  },
  beforeMount() {
    this.debounce_rangeChange = _debounce((e, name) => {
      this.changeRange(e, name);
    }, 500);
  },
  methods: {
    ...mapMutations('catalog', {
      changeFiltersState: 'CHANGE_FILTER_STATE',
    }),
    onRangeChange(e, name) {
      if (this.mqIsMobile) {
        this.tempRangeValues[name] = e;
      } else {
        this.debounce_rangeChange.cancel();
        this.debounce_rangeChange(e, name);
      }
    },
    onRangeSlide(e, name) {
      if (this.mqIsMobile) {
        this.tempRangeValues[name] = e;
      } else {
        this.changeRange(e, name);
      }
    },
    onRadioClick(e, value) {
      this.radioChangeProcess(e, value);
      this.applyFilter();
    },
    onCheckClick(e, value) {
      this.checkChangeProcess(e, value);
      this.applyFilter();
    },
    applyMobileFilter() {
      Object.keys(this.tempRangeValues).forEach(name => {
        this.changeRange(this.tempRangeValues[name], name);
      });
      this.tempRangeValues = {};
    },
    radioChangeProcess(e, value) {
      if (!this.routeSegments.includes(value)) {
        this.routeSegments.push(value);
      }

      this.routeSegments = this.routeSegments.filter((s) => s === value);
    },
    checkChangeProcess(e, value) {
      if (e) {
        !this.routeSegments.includes(value) && this.routeSegments.push(value);
      } else if (this.routeSegments.includes(value)) {
        const index = this.routeSegments.indexOf(value);

        if (index !== -1) this.routeSegments.splice(index, 1);
      }
    },
    applyFilter() {
      const { type, entityCode, code, routeSegments, tagCode } = this;

      const path = concatCatalogRoutePath(
        type,
        entityCode,
        code,
        routeSegments,
        tagCode,
      );
      const query = { ...this.$route.query };
      delete query.page;

      this.$router.replace({ path, query });
    },
    onShowMoreClick({ name }) {
      const map = this.filtersStateMap || {};
      this.changeFiltersState({
        name,
        value: { ...map[name], showMore: !map[name].showMore },
      });
    },
    onIsExpandedClick({ name }) {
      const map = this.filtersStateMap || {};
      this.changeFiltersState({
        name,
        value: { ...map[name], isExpanded: !map[name].isExpanded },
      });
    },
    clearFilterUrl() {
      const { type, entityCode, code } = this;

      const query = { ...this.$route.query };
      delete query.page;

      return {
        path: generateCategoryUrl(type, entityCode, code),
        query,
      };
    },
    close() {
      if (this.routeSegments.length) {
        this.applyFilter();
      }

      this.$nextTick(() => {
        this.$emit('close');
      });
    },

    changeRange(values, name) {
      const { type, entityCode, code, routeSegments, tagCode } = this;
      const segment = `${name}-from-${values[0]}-to-${values[1]}`;
      const rangeRegex = new RegExp(`^${name}-`);

      let currentIndex = -1;
      for (let i = 0; i < routeSegments.length; i++) {
        if (routeSegments[i].match(rangeRegex)) {
          currentIndex = i;
          break;
        }
      }

      if (currentIndex !== -1) {
        if (routeSegments[currentIndex] === segment) return;
        routeSegments.splice(currentIndex, 1, segment);
      } else routeSegments.push(segment);

      const path = concatCatalogRoutePath(
        type,
        entityCode,
        code,
        routeSegments,
        tagCode,
      );
      const query = { ...this.$route.query };
      delete query.page;

      this.$router.replace({ path, query });
    },
  },
};
